import React from "react";

export const DownloadIcon = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.75 12.1785V4.5C12.75 4.08579 12.4142 3.75 12 3.75C11.5858 3.75 11.25 4.08579 11.25 4.5V12.1785L8.82617 9.26986C8.56099 8.95165 8.08807 8.90866 7.76986 9.17383C7.45165 9.43901 7.40866 9.91193 7.67383 10.2301L11.4238 14.7301C11.5663 14.9011 11.7774 15 12 15C12.2226 15 12.4337 14.9011 12.5762 14.7301L16.3262 10.2301C16.5913 9.91193 16.5483 9.43901 16.2301 9.17383C15.9119 8.90866 15.439 8.95165 15.1738 9.26986L12.75 12.1785Z" fill="#3A94FF"/>
        <path d="M2.25 16.5C2.66421 16.5 3 16.8358 3 17.25V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V17.25C21 16.8358 21.3358 16.5 21.75 16.5C22.1642 16.5 22.5 16.8358 22.5 17.25V20.25C22.5 21.4926 21.4926 22.5 20.25 22.5H3.75C2.50736 22.5 1.5 21.4926 1.5 20.25V17.25C1.5 16.8358 1.83579 16.5 2.25 16.5Z" fill="#3A94FF"/>
      </svg>
    </>
  );
};
